import {
  faEnvelope,
  faGlobe,
  faHeadset,
} from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { TrlFormattedMessagePlain } from '»utils/i18n';

import {
  ContactsContainerStyled,
  ContactsStyled,
  FontAwesomeIconStyled,
  InfoContainer,
  TypographyStyled,
} from './ContactsAurea.styles';
import { SocialNetworksAurea } from './SocialNetworks';

export const ContactsAurea = () => {
  const email = TrlFormattedMessagePlain({ id: 'TRLT_UI-EMAIL_AUREA' });
  const site = TrlFormattedMessagePlain({ id: 'TRLT_UI-SITE_AUREA' });

  return (
    <ContactsContainerStyled>
      <Box>
        <ContactsStyled>
          <FormattedMessage id="TRLT_UI-TITULO_AUREA" />
        </ContactsStyled>

        <InfoContainer href={`mailto:${email}`}>
          <FontAwesomeIconStyled icon={faEnvelope} />
          <TypographyStyled>{email}</TypographyStyled>
        </InfoContainer>
        <InfoContainer>
          <FontAwesomeIconStyled icon={faHeadset} />
          <TypographyStyled>
            <FormattedMessage id="TRLT_UI-PHONE_NUMBER_AUREA" />
          </TypographyStyled>
        </InfoContainer>
        <InfoContainer href={`https://${site}`} target="_blank">
          <FontAwesomeIconStyled icon={faGlobe} />
          <TypographyStyled>{site}</TypographyStyled>
        </InfoContainer>
      </Box>
      <SocialNetworksAurea />
    </ContactsContainerStyled>
  );
};
